import FamilyApplication from './FamilyApplication';

export default FamilyApplication;
